import { Component, Input, OnChanges } from "@angular/core";

import { MobileComponent } from "../../mobile/interface/mobile.component";
import { HeadingWidgetService } from "../service/heading-widget.service";
import { MaterialModule } from "src/app/shared/module/material.module";
import { ReadMoreComponent } from "../../read-more/read-more.component";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";

@Component({
  selector: "rfc-description-widget",
  templateUrl: "./description-widget.component.html",
  styleUrls: ["./description-widget.component.scss"],
  standalone: true,
  imports: [
    MaterialModule,
    ReadMoreComponent,
    I18nPipe
  ]
})
export class DescriptionWidgetComponent extends MobileComponent {
  @Input() description;
  constructor(private headingWidgetService: HeadingWidgetService) {
    super();
  }
}
